import { connect } from 'react-redux'
import { ActionTypes } from '../actions'

const { SET_MONTH, SET_STATISTICS } = ActionTypes

import {
  fetchInitialData,
  setPublicHolidaysInStore,
} from '../actions'

import AccountingComponent from '../components/AccountingComponent'

const mapStateToProps = (state) => {
  return {
    accounting: state.accounting,
  }
}

const mapDispatchToProps = (dispatch) => ({
  fetchData: () => dispatch(fetchInitialData()),
  setMonth: (month) => dispatch({
    type: SET_MONTH,
    month: month,
  }),
  setStatistics: (statistics) => dispatch({
    type: SET_STATISTICS,
    statistics: statistics,
  }),
  setPublicHolidays: (publicHolidays) => dispatch(setPublicHolidaysInStore(publicHolidays)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountingComponent)
